var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBirdNotReach(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 134,
    viewBox: "0 0 142 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 39L64.9741 37.8593L63.8946 36.9375L62.9147 37.9646L64 39ZM108.618 78.4954C109.444 78.4303 110.06 77.708 109.995 76.8822L108.935 63.4239C108.87 62.598 108.148 61.9813 107.322 62.0463C106.496 62.1114 105.879 62.8337 105.944 63.6595L106.887 75.6225L94.9239 76.565C94.098 76.6301 93.4813 77.3523 93.5463 78.1782C93.6114 79.004 94.3337 79.6208 95.1595 79.5557L108.618 78.4954ZM23.5853 83.5354L65.0853 40.0354L62.9147 37.9646L21.4147 81.4646L23.5853 83.5354ZM63.0259 40.1407L107.526 78.1407L109.474 75.8593L64.9741 37.8593L63.0259 40.1407Z",
    fill: "#F44C5C",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6792 73.1672L100.241 27.494C100.241 27.494 82.0052 26.7209 77.557 41.701C73.1002 56.7101 86.6792 73.1672 86.6792 73.1672Z",
    fill: "#009846"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1766 27.4991C98.2347 27.4917 98.291 27.4898 98.3475 27.488C95.8308 36.6849 92.8997 46.4613 89.9758 55.3582C92.3856 46.3331 95.2643 36.566 98.1766 27.4991Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4349 27.8089C95.5132 27.7955 95.5845 27.7858 95.6554 27.7763C93.1991 36.6867 90.3661 46.0916 87.5525 54.6802C89.8716 45.9812 92.6247 36.595 95.4349 27.8089Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6003 28.3902C92.7009 28.365 92.794 28.3439 92.8887 28.3172C90.5156 36.8639 87.8085 45.8043 85.1238 54.0007C87.3375 45.7183 89.9369 36.807 92.6003 28.3902Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8909 72.9068L23.16 49.4686L31.6946 50.1254L34.4296 38.1548L56.1247 67.6744L47.8909 72.9068Z",
    fill: "#009846"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.122 67.5819L54.1261 64.8627L46.4781 71.5088L47.8542 72.8363L56.122 67.5819Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0151 72.1223C43.5428 66.9133 38.2759 61.5017 33.2346 55.8991C38.7085 61.1066 43.9721 66.5211 49.0151 72.1223Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0001 68.3123C49.971 62.3387 45.1692 56.1862 40.6127 49.8674C45.6436 55.8397 50.4418 61.9949 55.0001 68.3123Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9564 70.2498C46.6816 64.5586 41.6249 58.6779 36.8052 52.6198C42.0818 58.3096 47.135 64.1932 51.9564 70.2498Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5175 69.2574C48.281 63.3954 43.266 57.3478 38.4912 51.1271C43.7295 56.9877 48.7411 63.0379 53.5175 69.2574Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4732 71.195C45.0034 65.6683 39.7455 59.9453 34.7181 54.0374C40.1894 59.5625 45.4443 65.2885 50.4732 71.195Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0374 94.9463C89.0374 94.9463 98.9278 96.6099 102.427 87.2481C105.926 77.8864 96.6165 71.2793 96.6165 71.2793C96.6165 71.2793 87.2092 50.6929 69.076 50.963C53.3083 51.1977 46.9813 63.0862 48.4479 75.062C49.8995 86.9152 55.5714 95.5042 67.8327 96.3492C80.0943 97.1942 89.0374 94.9463 89.0374 94.9463Z",
    fill: "#009846"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0273 92.2986C68.9126 96.5718 73.9434 95.4512 78.7229 96.5565C80.9163 96.0546 89.8203 94.9813 92.384 94.9984L95.5931 94.1952C96.8545 93.8088 97.4642 93.4058 98.897 92.3061C98.999 92.2279 99.7231 92.0312 100.051 91.7514C100.246 91.5858 100.031 91.2619 100.225 91.0783C100.61 90.7055 100.544 90.5541 100.894 90.1081C101.063 89.878 101.504 89.6656 101.743 89.2892C101.981 88.9128 101.737 88.4647 102.585 87.6459C102.573 85.9968 103.308 85.4865 103.422 85.1781L103.404 82.7045C102.485 73.6292 97.4448 72.1074 95.4277 71.1587L95.2752 71.09C95.2295 71.0693 95.1858 71.0541 95.1532 71.035L95.0618 70.9938C95.0387 70.9835 95.0179 70.9785 95.0083 70.9697L94.9854 70.9595L94.9799 70.9614C94.9799 70.9614 86.3426 67.4698 75.6625 70.7489C64.8029 74.0847 63.6075 84.5456 67.0273 92.2986Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M82.29 80.2959C80.4226 84.4418 82.3684 89.3061 86.6379 91.1648C88.6806 92.0541 91.2695 91.9905 93.2479 91.4294C95.2744 90.8549 100.846 90.0644 100.846 90.0644C100.846 90.0644 104.229 85.1063 103.362 81.7875L93.3985 76.156C89.1291 74.2972 84.1551 76.1554 82.29 80.2959Z",
    fill: "white",
    fillOpacity: 0.501961
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0303 94.7627C93.3708 92.1351 93.1166 85.9897 91.9804 84.0647C92.5428 83.7928 93.8365 83.2498 94.5129 83.2527C95.3584 83.2563 97.9369 92.3193 97.0953 93.1386C96.422 93.794 92.8758 94.7663 92.0303 94.7627Z",
    fill: "#A9E8EC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3566 84.3688L102.986 83.8886L108.109 89.0843L98.3566 84.3688Z",
    fill: "#263138"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3545 84.3804L104.396 87.3029L101.552 87.0472L98.3545 84.3804Z",
    fill: "#36464F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7574 68.922L20.6716 79.2736C20.6716 79.2736 29.0112 94.9538 44.7827 91.5586C60.5845 88.1568 68.7574 68.922 68.7574 68.922Z",
    fill: "#009846"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7574 68.922L20.6716 79.2736C20.6716 79.2736 29.0112 94.9538 44.7827 91.5586C60.5845 88.1568 68.7574 68.922 68.7574 68.922Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7614 81.0454C21.7263 81.0004 21.6967 80.954 21.6671 80.9076C31.2268 78.6416 41.515 76.4469 51.0045 74.6648C41.6533 76.9386 31.3992 79.1727 21.7614 81.0454Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3788 83.2127C23.3277 83.1534 23.2839 83.0985 23.2401 83.0435C32.5108 80.8631 42.4148 78.7631 51.5712 77.0352C42.5592 79.2298 32.7118 81.3881 23.3788 83.2127Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2863 85.3282C25.2139 85.2559 25.1487 85.188 25.0778 85.1213C33.9784 83.0441 43.4003 81.0599 52.1382 79.4104C43.5552 81.4951 34.2129 83.556 25.2863 85.3282Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3927 94.9482C69.7204 95.5379 68.4581 97.4286 67.5815 97.988C66.584 98.6243 65.5005 98.5152 64.803 98.1779",
    stroke: "#263138",
    strokeWidth: 1.20534,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9338 94.0262C68.2613 94.6161 66.999 96.5067 66.1223 97.0659C65.125 97.7024 64.0415 97.5934 63.344 97.2559",
    stroke: "#263138",
    strokeWidth: 1.20534,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4739 93.1044C66.8014 93.6942 65.5392 95.5847 64.6626 96.1441C63.6653 96.7805 62.5819 96.6714 61.8841 96.334",
    stroke: "#263138",
    strokeWidth: 1.20534,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6973 93.5902C62.9684 94.3622 61.5496 96.1455 60.6282 96.6331C59.5798 97.188 58.5085 96.9935 57.8414 96.6019",
    stroke: "#263138",
    strokeWidth: 1.20534,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3213 92.5558C61.5924 93.3281 60.1736 95.1113 59.2521 95.5989C58.2035 96.1537 57.1324 95.959 56.4653 95.5677",
    stroke: "#263138",
    strokeWidth: 1.20534,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9453 91.5217C60.2164 92.2939 58.7975 94.0769 57.8759 94.5647C56.8276 95.1195 55.7564 94.9249 55.0894 94.5335",
    stroke: "#263138",
    strokeWidth: 1.20534,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M90.608 81.5641L96.9578 79.313L96.9672 80.7203L90.9618 82.8506L90.608 81.5641Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4061 78.4548L97.0546 83.3174L95.7033 83.8484L91.3056 79.25L92.4061 78.4548Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirdNotReach);
export default __webpack_public_path__ + "static/media/bird_not_reach.1a5129f4995c91ba917f3701539ceb24.svg";
export { ForwardRef as ReactComponent };